import { actionWithDatapoint } from 'owa-analytics-actions';
import { action } from 'satcheljs';

import getEntryPoint from '../selectors/getEntryPoint';
import { getUserMailboxGuid } from '../utils/getMailboxGuid';

import type ServicesRequestStatus from '../store/schema/ServicesRequestStatus';
import type RecipientInfo from '../store/schema/RecipientInfo';
/**
 * Action to show the ShareModal to share events
 */

export const setShareModalInfo = actionWithDatapoint(
    'setShareModalInfo',
    (
        eventId: string,
        eventTitle: string,
        eventTheme: string,
        eventMeetingTypeDuration: string,
        eventMeetingDescription: string,
        allowedAttendees: RecipientInfo[],
        isPrivate: boolean
    ) => ({
        eventId,
        eventTitle,
        eventTheme,
        eventMeetingTypeDuration,
        eventMeetingDescription,
        allowedAttendees,
        isPrivate,
    }),
    actionMessage => ({
        customData: {
            meetingTypeId: actionMessage.eventId,
            entryPoint: getEntryPoint(),
            mailboxGuid: getUserMailboxGuid(),
        },
    })
);

/**
 * Action to show share modal
 */
export const setShowShareModal = action('setShowShareModal', (showModal: boolean) => ({
    showModal,
}));

/**
 * Action set share link
 */
export const setShareModalShareLink = action('setShareModalShareLink', (shareLink: string) => ({
    shareLink,
}));

/**
 * Action set share link isSingleUse policy
 */
export const setShareLinkIsSingleUse = action(
    'setShareLinkIsSingleUse',
    (isSingleUse: boolean) => ({
        isSingleUse,
    })
);

/**
 * Action set share link isAttendeeAuthRequired policy
 */
export const setShareLinkIsAttendeeAuthRequired = action(
    'setShareLinkIsAttendeeAuthRequired',
    (isAttendeeAuthRequired: boolean) => ({
        isAttendeeAuthRequired,
    })
);

/**
 * Action set share create single use link status
 */
export const setCreateShareLinkStatus = action(
    'setCreateShareLinkStatus',
    (status: ServicesRequestStatus) => ({
        status,
    })
);

/**
 * Action to dismiss/close the ShareModal to share events
 */
export const shareModalDismiss = action('shareModalDismiss');

/**
 * Action called when the message in the email text field when sharing an event by email changes
 */
export const shareModalEmailMessageChanged = action(
    'shareModalEmailMessageChanged',
    (_event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, message?: string) => ({
        message,
    })
);

/**
 * Action to set share successful
 */
export const setShareSuccessful = action('setShareSuccessful', (shareSuccessful: boolean) => ({
    shareSuccessful,
}));
